import { SvgIcon, Typography } from "@mui/material";
import { ReactNode } from "react";
import { useStyle } from "./style";

interface IParams {
    content: ReactNode;
    icon: ReactNode;
    isAlert?: boolean;
    hasError?: boolean;
}

export const WarningBanner = (props: IParams) => {
    const { content, icon, isAlert, hasError } = props;
    const { classes } = useStyle({ isAlert, hasError });

    return (
        <div className={classes.container}>
            <SvgIcon className={classes.icon} color="secondary">
                {icon}
            </SvgIcon>
            <Typography className={classes.text} color="secondary" variant="normal">
                {content}
            </Typography>
        </div>
    );
};
